import { getS2ItemValue } from './lootbox';

export const IMPOSTOR_TOKEN_MULTIPLIER = 4;

export const LOOTBOX_VALUES = {
  normal: 1,
  shiny: 2,
  stattrak: 2,
  vfxbox: 8,
  elite: 20,
  god: 80,
};

// S2 lootbox values (match new shop prices)
export const LOOTBOX_VALUES_S2 = {
  normal: 1,
  shiny: 3,
  stattrak: 3,
  vfxbox: 10,
  elite: 25,
  god: 100,
};

export const LOOTBOX_LABELS = {
  normal: '🎁',
  shiny: '✨',
  stattrak: '📊',
  vfxbox: '🎬',
  elite: '💎',
  god: '👑',
};

export const RICHNESS_RANKS = [
  { name: 'Homeless', min: 0, color: '#666' },
  { name: 'Broke', min: 10, color: '#8B8B8B' },
  { name: 'Poor', min: 50, color: '#CD7F32' },
  { name: 'Middle Class', min: 150, color: '#C0C0C0' },
  { name: 'Rich', min: 400, color: '#FFD700' },
  { name: 'Country Club', min: 1000, color: '#4ADE80' },
  { name: 'Mr Moneybags', min: 2500, color: '#60A5FA' },
  { name: 'Ryan Nowell', min: 5000, color: '#C084FC' },
];

// Item value placeholder — S1 uses 0 (items have no networth value)
export const DEFAULT_ITEM_VALUE = 0;

export function calculateNetWorth(userData, isSeason2 = false) {
  const crew = userData.crewmateTokens || 0;
  const imp = userData.imposterTokens || 0;
  const liquid = crew + (imp * IMPOSTOR_TOKEN_MULTIPLIER);

  const lootboxValues = isSeason2 ? LOOTBOX_VALUES_S2 : LOOTBOX_VALUES;
  let lootboxValue = 0;
  const stock = userData.lootboxStock || {};
  const lootboxCounts = {};
  for (const [type, count] of Object.entries(stock)) {
    const c = count || 0;
    if (c > 0 && lootboxValues[type]) {
      lootboxCounts[type] = c;
      lootboxValue += lootboxValues[type] * c;
    }
  }

  // Items — S2 uses per-rarity values with modifier multipliers
  const inventory = userData.lootboxInventory || [];
  let itemsValue = 0;
  if (isSeason2) {
    for (const item of inventory) {
      itemsValue += getS2ItemValue(item);
    }
  } else {
    itemsValue = inventory.length * DEFAULT_ITEM_VALUE;
  }

  // Stocks — portfolio value cached on stockHoldings doc
  const stocksValue = userData.stockPortfolioValue || 0;

  const total = liquid + lootboxValue + itemsValue + stocksValue;

  return {
    liquid,
    lootboxes: lootboxValue,
    lootboxCounts,
    items: itemsValue,
    itemCount: inventory.length,
    stocks: stocksValue,
    total,
  };
}

export function getRichnessRank(netWorth) {
  for (let i = RICHNESS_RANKS.length - 1; i >= 0; i--) {
    if (netWorth >= RICHNESS_RANKS[i].min) return RICHNESS_RANKS[i];
  }
  return RICHNESS_RANKS[0];
}
